import Velocity from 'velocity-animate';

/**
 * Get width of elem + margin
 * @param {DOMObject} element
 * @return {Number}
 */
export function outerWidth(element) {
  const style = getComputedStyle(element);
  const width = element.offsetWidth + parseInt(style.marginLeft) + parseInt(style.marginRight);
  return typeof width === 'number' ? width : null;
}

/**
 * Uses velocity to animate the carousel frame
 * @param {DOMObject} element - el to move
 * @param {Number} xPositionValue - new left position
 * @param {Function} onComplete - callback
 * @param {Boolean} shouldAnimate - should we animate there or just change position?
 */
export function moveToSlide(element, xPositionValue, onComplete = function() {}, shouldAnimate) {
  if (shouldAnimate === true) {
    Velocity(
      element,
      {
        left: xPositionValue,
        duration: 1000,
        easing: 'easeOutCubic',
        complete: onComplete,
      },
      [500, 30],
    );
  } else {
    onComplete();
  }
}

/**
 * Calculate swipe direction based on x and y distance coords
 * @param {Number} x1 - start x position
 * @param {Number} x2 - end x position
 * @param {Number} y1 - start y position
 * @param {Number} y2 - end y position
 * @return {Number}
 */
export function getSwipeDirection(x1, x2, y1, y2) {
  const xDist = x1 - x2;
  const yDist = y1 - y2;
  const r = Math.atan2(yDist, xDist);
  let swipeAngle = Math.round((r * 180) / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0) {
    return 1;
  }
  if (swipeAngle <= 360 && swipeAngle >= 315) {
    return 1;
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return -1;
  }
  return 0;
}
